// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jkYb","controls":"styles_controls__6ZtKq","charLimit":"styles_charLimit__1KdbX","input":"styles_input__1x-7P","send":"styles_send__2SbC8"};